import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setGroupFilter, fetchUserFiles, downloadFile, uploadFile, deleteFile, initUpload } from 'actions/Files';
import keys from 'lodash/keys';
import includes from 'lodash/includes';
import toLower from 'lodash/toLower';
import deburr from 'lodash/deburr';
import { iconSelect } from 'utils/iconSelect';

import browser from 'detect-browser';

import { Col } from 'react-flexbox-grid';
import Loading from 'components/Loading';
import Alert from 'components/Alert';
import FileUpload from 'components/FileUpload';

import { ListItem } from 'material-ui/List';
import Paper from 'material-ui/Paper';
import Subheader from 'material-ui/Subheader';
import FontIcon from 'material-ui/FontIcon';
import PanelMessage from 'components/panels/PanelMessage';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import { dateTime } from 'utils/dateTools';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import { Toolbar, ToolbarGroup, ToolbarSeparator } from 'material-ui/Toolbar';
import DropDownMenu from 'material-ui/DropDownMenu';

import sortBy from 'lodash/sortBy';


import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

const styles = {
  subheader: {
    fontSize: 20,
    fontWeight: 300,
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    paddingLeft: 8,
    paddingRight: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};

class Files extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertFileName: '',
      removeDoc: null,
      searchFilter: '',
      alertOpen: false,
    };
  }

  componentDidMount() {
    this.props.init();
    // this.props.fetch();
  }

  openAlert = (alertFileName, removeDoc) => this.setState({ alertOpen: true, removeDoc, alertFileName });
  closeAlert = () => this.setState({ alertOpen: false, removeDoc: null, alertFileName: '' });

  alertOnOk = () => {
    if (this.state.removeDoc) {
      this.props.remove(this.state.removeDoc);
      this.closeAlert();
    }
  }
  alertOnCancel = () => this.closeAlert();

  keyDownText = (ev) => {
    if (ev.keyCode === 13) {
      const searchFilter = ev.target.value;
      this.setState({ searchFilter });
    }
  }

  render() {
    const {
      loaded,
      error,
      hasError,
      uploadHasError,
      groupedFiles,
      groupFilter,
      files,
      fetch,
      download,
      upload,
      documentTypes,
      documentTypesById,
      uploading,
      setFilter,
      hideUpload,
    } = this.props;

    const {
      alertOpen,
      alertFileName,
    } = this.state;

    if (!loaded) {
      return <Loading />;
    }
    if (hasError) {
      return (
        <Col xs={12} sm={12} md={8} mdOffset={2} style={{ paddingTop: 0, paddingBottom: 16 }}>
          <PanelMessage
            type="error"
            iconName="error"
            message={error && error.Message ? error.Message : <FormattedMessage id="repository.error" />}
          />
        </Col>
      );
    }
    const groups = sortBy(keys(groupedFiles), o => get(documentTypesById, [o, 'Name']));

    const displayFiles = groupFilter ? groupedFiles[groupFilter] : files;

    const displayFilesFilter = this.state.searchFilter ?
      displayFiles.filter(x =>
        includes(toLower(deburr(`${x.Name}${x.Extension}`)), toLower(deburr(this.state.searchFilter)))) :
      displayFiles;

    return (
      <Col xs={12} sm={12} md={8} mdOffset={2} style={{ paddingTop: 0, paddingBottom: 16 }}>
        { !hideUpload &&
          <div>
            <Subheader style={styles.subheader}><FormattedMessage id="repository.uploadTitle" /></Subheader>
            <FileUpload onSubmit={upload} selectOptions={documentTypes} uploading={uploading} />
          </div>
        }
        {uploadHasError &&
        <PanelMessage
          type="error"
          iconName="error"
          message={error && error.Message ? error.Message : <FormattedMessage id="repository.error" />}
        />
        }
        <Subheader style={styles.subheader}><FormattedMessage id="repository.title" /></Subheader>
        <Toolbar>
          <ToolbarGroup firstChild>
            <DropDownMenu
              value={groupFilter || 13371337}
              style={{ margin: 0, flex: '0 1 auto', maxWidth: 200 }}
              iconButton={<FontIcon className="material-icons">filter_list</FontIcon>}
            >
              {[
                <MenuItem
                  key="all"
                  value={13371337}
                  primaryText={<FormattedMessage id="repository.all" />}
                  onClick={() => setFilter(null)}
                />,
                ...groups.map((v, i) =>
                  (<MenuItem
                    key={i}
                    value={v}
                    primaryText={`${documentTypesById[v] && documentTypesById[v].Name}`}
                    onClick={() => setFilter(v)}
                  />)),
              ]}
            </DropDownMenu>
            <div style={{ display: 'flex', alignItems: 'center' }} className="hide-mobile">
              <ToolbarSeparator style={{ margin: 0 }} />
              <FontIcon
                style={{ marginLeft: 8, marginRight: 8 }}
                className="material-icons"
                onClick={() => this.filterInput.focus()}
              >
                search
              </FontIcon>
              <TextField
                ref={(r) => { this.filterInput = r; }}
                hintText={<FormattedMessage id="repository.search" />}
                onKeyDown={this.keyDownText}
                onChange={(e) => {
                  if (browser.name !== 'ie') {
                    this.setState({ searchFilter: e.target.value });
                  }
                }}
              />
            </div>
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            <FlatButton
              style={{ margin: 10 }}
              onClick={fetch}
              label={<FormattedMessage id="repository.refresh" />}
              icon={<FontIcon className="material-icons">refresh</FontIcon>}
            />
          </ToolbarGroup>
        </Toolbar>
        {(loaded && files.length < 1 && hideUpload) && <PanelMessage message={<FormattedMessage id="repository.noFiles" />} type="info" iconName="info" />}
        {(loaded && files.length < 1 && !hideUpload) && <PanelMessage message={<FormattedMessage id="repository.noFiles.CanAdd" />} type="info" iconName="info" />}
        {(loaded && displayFilesFilter.length < 1 && files.length > 0) && <PanelMessage message={<FormattedMessage id="repository.noFilesFilter" />} type="info" iconName="info" />}
        <Paper>
          {displayFilesFilter.map(x => (
            <div key={x.DocumentId}>
              <ListItem
                className="cy-list-item"
                leftIcon={<FontIcon className="material-icons">{iconSelect(x.Extension)}</FontIcon>}
                primaryText={`${x.Name}${x.Extension}`}
                secondaryText={`${documentTypesById[x.ObjectDocumentType] && documentTypesById[x.ObjectDocumentType].Name} ${dateTime(x.AddDate)}`}
                disabled
                rightIconButton={
                  <IconMenu
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                    iconButtonElement={<IconButton><FontIcon className="material-icons">more_vert</FontIcon></IconButton>}
                  >
                    <MenuItem
                      primaryText={<FormattedMessage id="repository.download" />}
                      onClick={() => download(x.DocumentId)}
                      leftIcon={
                        <FontIcon className="material-icons">file_download</FontIcon>
                      }
                    />
                    <Divider />
                    <MenuItem
                      style={{ color: '#cd5c5c' }}
                      primaryText={<FormattedMessage id="repository.delete" />}
                      onClick={() => this.openAlert(`${x.Name}${x.Extension}`, x)}
                      leftIcon={
                        <FontIcon color="#cd5c5c" className="material-icons">delete</FontIcon>
                      }
                    />
                  </IconMenu>
                }
              />
              <Divider />
            </div>
          ))}
        </Paper>
        <Alert
          open={alertOpen}
          text={<span><FormattedMessage id="repository.alert" /><strong>{alertFileName}</strong>?</span>}
          onOk={this.alertOnOk}
          onCancel={this.alertOnCancel}
        />
      </Col>
    );
  }
}

Files.propTypes = {
  fetch: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  download: PropTypes.func.isRequired,
  upload: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  loaded: PropTypes.bool.isRequired,
  uploading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  uploadHasError: PropTypes.bool.isRequired,
  error: PropTypes.object,
  documentTypesById: PropTypes.object,
  documentTypes: PropTypes.arrayOf(PropTypes.shape({
    FileRepositoryObjectDocumentTypeID: PropTypes.number,
    Name: PropTypes.string,
  })),
  groupedFiles: PropTypes.object,
  groupFilter: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string,
    Extension: PropTypes.string,
    DocumentId: PropTypes.string,
    ObjectDocumentTypeName: PropTypes.string,
    AddDate: PropTypes.string,
  })),
  hideUpload: PropTypes.bool,
};

const checkHideUpload = vbk => vbk['Hide.FileUpload'] && vbk['Hide.FileUpload'].Value === 'true';

export default connect(
  ({ FileReducer, WebValuesReducer: { valuesByKey } }) => ({ ...FileReducer, hideUpload: checkHideUpload(valuesByKey) }),
  dispatch => ({
    fetch: () => dispatch(fetchUserFiles()),
    init: () => dispatch(initUpload()),
    download: id => dispatch(downloadFile(id)),
    upload: formData => dispatch(uploadFile(formData)),
    remove: id => dispatch(deleteFile(id)),
    setFilter: filter => dispatch(setGroupFilter(filter)),
  }),
)(Files);



// WEBPACK FOOTER //
// ./src/containers/Files.js